{
  "name": "user-documents-fe",
  "version": "1.5.1-develop.0",
  "scripts": {
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --coverage"
  },
  "private": true,
  "type": "module",
  "dependencies": {
    "@angular/animations": "^22.2.0",
    "@angular/common": "^22.2.0",
    "@angular/compiler": "^22.2.0",
    "@angular/core": "^22.2.0",
    "@angular/forms": "^22.2.0",
    "@angular/platform-browser": "^22.2.0",
    "@angular/platform-browser-dynamic": "^22.2.0",
    "@angular/router": "^22.2.0",
    "@vitest/coverage-v8": "5",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1",
    "vite": "^8.3.1",
    "vitest": "5"
  },
  "devDependencies": {
    "@angular/build": "^22.2.0",
    "@angular/cdk": "^22.2.0",
    "@angular/cli": "^22.2.0",
    "@angular/compiler-cli": "^22.2.0",
    "@angular/material": "^22.2.0",
    "@eslint/js": "^10.0.1",
    "@sparbanken-syd/auth-backend": "^2.7.1",
    "@sparbanken-syd/personnummer": "^3.1.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@sparbanken-syd/spb-file-mgmt": "^1.4.0",
    "@sparbanken-syd/user-documents-backend": "^1.2.0",
    "@types/jsdom": "^30",
    "angular-eslint": "^22.5.0",
    "eslint": "^10.11.0",
    "jsdom": "^30.1.1",
    "postcss": "^8.5.6",
    "stylelint": "^17.15.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "^6.0.3",
    "typescript-eslint": "^8.50.1"
  }
}
